document.addEventListener('DOMContentLoaded', function () {
  var roots = document.querySelectorAll('.collection-hero-trustpilot');
  if (!roots.length) return;

  var locale = (window.Shopify && window.Shopify.locale) || 'nl';
  var country = (window.Shopify && window.Shopify.country) || 'NL';
  var lang = String(locale).toLowerCase().split('-')[0];
  var countryCode = String(country).toLowerCase();
  var host = (window.location.hostname || '').toLowerCase();
  var reviewLabel = 'recensies';
  if (lang === 'de' || countryCode === 'de' || /\.de$/.test(host)) {
    reviewLabel = 'Bewertungen';
  } else if (lang === 'it' || countryCode === 'it' || /\.it$/.test(host)) {
    reviewLabel = 'recensioni';
  } else if (lang === 'en') {
    reviewLabel = 'reviews';
  }

  fetch('https://widget.trustpilot.com/trustbox-data/56278e9abfbbba0bdcd568bc?businessUnitId=642f26c5901cb63488f5c498&locale=' + locale + '-' + country)
    .then(function (response) { return response.json(); })
    .then(function (data) {
      var businessUnit = data && data.businessUnit;
      if (!businessUnit) return;

      var reviewCount = businessUnit.numberOfReviews.total.toLocaleString(locale);
      var trustScore = businessUnit.trustScore;

      roots.forEach(function (root) {
        root.querySelectorAll('.trustCount').forEach(function (el) {
          el.innerHTML = reviewCount + '+ ' + reviewLabel;
        });
        root.querySelectorAll('.trustStar').forEach(function (el) {
          el.innerHTML = trustScore;
        });
        var starsWrapper = root.querySelector('.collection-hero-trustpilot__stars');
        if (starsWrapper) {
          starsWrapper.setAttribute('aria-label', trustScore + '/5');
        }
      });
    })
    .catch(function () {});
});
